// Manages active state of links in subnavigation list
// (() => {

//     const currentURL = window.location.href

//     const links = document.querySelectorAll('.maje-subnavigation li[data-collection-handle]')
//     links.forEach(link => {

//         const handle = link.getAttribute('data-collection-handle')
//         if (currentURL.includes(handle)) link.setAttribute('active', true)
//     })

// })()

// Manages height of banner in product grid
const bannerHeightManager = () => {

    if(window.innerWidth < 768) {
        checkMedia('.maje-special-banner__mobile')
    } else {
        checkMedia('.maje-special-banner__desktop')
    }

    function checkMedia(selector) {
        const banner = document.querySelector(selector)
        if (!banner) return

        const cardMediaSampleHeight = document.querySelector('.swiper .media img').offsetHeight
        console.log(cardMediaSampleHeight)
        banner.style.height = `${cardMediaSampleHeight}px`
    }
    
}

window.addEventListener('resize', () => {
    bannerHeightManager()
})

bannerHeightManager()